import _ from "lodash";

import {
  Component,
} from "react";
import {
  Alert,
  Button,
  Col,
  FormControl,
  FormGroup,
  FormText,
  Row,
} from "react-bootstrap";
import {
  Link,
} from "react-router-dom";
import store from "CommonState/store";
import apifetch from "CommonCore/apifetch";
import {
  ControlGenerators,
} from "CommonComponents/detail-view";
import DashboardFooter from "Components/dashboard-footer";
import {
  Panel,
} from "CommonComponents/bricks";
import {
  v4 as uuidv4,
} from "uuid";
import logo from "../img/logo.png";

const PAGE_LOGIN = 0;
const PAGE_INFO = 1;
const PAGE_REGISTER = 2;
const PAGE_MAILSENT = 3;
const PAGE_FILLPROFILE = 4;
const PAGE_PWD_RESET = 5; // Seite mit Eingabe der E-Mailasdresse
const PAGE_PWD_RESET_INFO = 6;

const RegisterLink1 = ({ onClick }) => {
  return <span>Sie haben keinen ZIM-Account, klicken Sie bitte <a onClick={onClick}>hier</a></span>;
};

const RegisterLink2 = ({ onClick }) => {
  return <span>Für <b>alle anderen Vertragsarten</b> (inkl. <b>Lehraufträgen</b>) registrieren Sie sich bitte mit Ihrer <b>externen E-Mail-Adresse</b>, über die Sie die Benachrichtigung vom e-Portal erhalten haben. Zur Registrierung gelangen Sie <a onClick={onClick}>hier</a></span>;
};


const RegisterInfo = ({ onOk, onCancel }) => {
  // Zwischenseite mit Erklärung zu den Gründen für eine lokale Registrierung
  return <Panel><div style={{ textAlign: "left" }}>
    <p>Eine lokale Registrierung ist nur dann zulässig, wenn Sie keinen gültigen ZIM-Account haben.</p>
    <p>
      Sollten Sie als Hilfskraft einen ZIM-Account haben, müssen Sie sich zwingend mit diesem anmelden, da anderenfalls eine Verknüpfung mit der vorgesehenen Hilfskraft-Stelle nicht möglich ist. Für alle anderen Verträge (z.B. Lehrauftrag, Tarifanstellung) darf keine Registrierung mit Ihrem ZIM-Account erfolgen.
    </p>
    <p>
      Sollten Sie keinen ZIM Account besitzen, dann können Sie sich hier registrieren. Es ist erforderlich, dass Sie sich mit der E-Mail Adresse registrieren, über die Sie die Benachrichtigung vom e-Portal erhalten haben, dass für Sie eine Stelle vorgesehen ist.
    </p></div><br /><br />
  <Button variant='outline-primary' onClick={onCancel}>Zurück zur Anmeldeseite</Button>
  {"\u00a0"}
  <Button variant='primary' onClick={onOk}>Weiter</Button>
  </Panel>;
};

const SentInfo = ({ onOk, email }) => {
  // Seite nach dem Versenden des Links
  return <Panel><p style={{ textAlign: "left" }}>Es wurde eine Mail mit einem Bestätigungslink an die von Ihnen angegebene Adresse
    <br />
    <h3>{email}</h3>
    versendet. Bitte schauen Sie in ihrem Postfach nach einer E-Mail mit dem Betreff 'Registrierung im BUW e-Portal'. Darin ist ein Link enthalten,
    der beim Klick das neue Konto aktiviert. Im Anschluss können Sie sich mit den verwendeten Angaben anmelden.<br />
    Der Link ist <strong>24 Stunden</strong> gültig.
  </p><br />
  <Button variant='primary' onClick={onOk}>Zurück zur Anmeldeseite</Button>
  </Panel>;
};

const ResetSentInfo = ({ onOk, email }) => {
  // Seite nach dem Versenden des Links
  return <Panel><p style={{ textAlign: "left" }}>Es wurde eine Mail mit einem Rücksetzungslink an
    <br />
    <h3>{email}</h3>
    versendet. Bitte schauen Sie in ihrem Postfach nach einer E-Mail mit dem Betreff 'Passwort vergessen'. Darin ist ein Link enthalten,
    der beim Klick eine Seite zur Eingabe des neuen Passwortes öffnet. Im Anschluss können Sie sich mit den verwendeten Angaben anmelden.<br />
    Der Link ist <strong>24 Stunden</strong> gültig.
  </p><br />
  <Button variant='primary' onClick={onOk}>Zurück zur Anmeldeseite</Button>
  </Panel>;
};

const FillInfo = () => {
  // Seite nach dem ersten Login eines ZIM-Nutzers
  return <Panel><p style={{ textAlign: "left" }}>Sie wurden automatisch mit Ihrem ZIM-Account registriert.
    Bitte vervollständigen Sie Ihre Profilinformationen:
  </p>
  </Panel>;
};

@store
export default class LoginPage extends Component {
  constructor() {
    super();
    this.state = {
      login: "",
      password: "",
      errorMessage: null,
      errorFlashToggle: 0,
      loginPage: PAGE_LOGIN,
      wartungshinweisePopup: false,
      showPassword: false, // Neuer State für Passwort-Anzeige
    };
  }

  async componentDidMount() {
    // Serverinfo lesen
    try {
      const serverinfo = await fetch("/serverinfo.json");
      const result = await serverinfo.json();
      this.setState({ serverinfo: result });
      this.props.refreshLoginToken(result);
    } catch(err) {
      // keine Serverinfo
      this.props.refreshLoginToken();
    }
  }

  // Neue Methode zum Umschalten der Passwort-Sichtbarkeit
  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword,
    }));
  };

  render() {
    const { loginPage, serverinfo, showPassword } = this.state;

    const cg = (label, name, type, required, helptext) => {
      const setValue = (schema, value) => {
        this.setState({ [name]: value });
      };
      return ControlGenerators.default({
        entity: this.state,
        leftCol: 5,
        rightCol: 6,
        schema: { display: label, field: name, type: type, required: required, helpText: helptext },
        onChange: setValue,
      });
    };

    return <span>
      <div className={`middle-box text-center ${ loginPage != PAGE_REGISTER ? "loginscreen" : "loginscreen-wide" }`}>
        <div>
          <div>
            <img src={logo} />
          </div>
          <h3>Willkommen im e-Portal</h3>
          <p>Einstellungsportal der Bergischen Universität Wuppertal</p>

          {serverinfo && !serverinfo.production && <Alert variant='warning'>
            <h3 className='funnyanimate'>Sie befinden sich auf dem <br /> {serverinfo.servername}</h3>
            <p style={{ fontSize: "larger" }}>Hier geht es zum <a href='https://e-portal.uni-wuppertal.de'>Produktivsystem</a> </p>
          </Alert>}

          {loginPage == PAGE_INFO && <RegisterInfo onOk={() => this.setState({ loginPage: PAGE_REGISTER })} onCancel={() => this.setState({ loginPage: PAGE_LOGIN })} />}

          {loginPage == PAGE_REGISTER && <h3>Lokale Registrierung</h3>}

          {loginPage == PAGE_MAILSENT && <SentInfo email={this.state.login} onOk={() => this.setState({ loginPage: PAGE_LOGIN })} />}

          {loginPage == PAGE_PWD_RESET_INFO && <ResetSentInfo email={this.state.login} onOk={() => this.setState({ loginPage: PAGE_LOGIN })} />}

          {loginPage == PAGE_FILLPROFILE && <span><h3>Erste Anmeldung</h3><FillInfo email={this.state.login} onOk={this.state.continueLogin} /></span>}

          {([PAGE_LOGIN, PAGE_REGISTER, PAGE_FILLPROFILE, PAGE_PWD_RESET].includes(loginPage)) &&
            <form action={null} className='m-t' role='form' onSubmit={this.process}>
              {this.state.errorMessage && <Alert
                variant='danger'
                className={"flash" + (this.state.errorFlashToggle + 1)}>
                {this.state.errorMessage}
              </Alert>}
              {this.state.wartungshinweisePopup &&
                    <Alert variant='info' className={"flash" + 0}>
                      Aktuell ist eine Anmeldung am e-Portal nicht möglich. Dies kann aufgrund von Wartungsarbeiten der Fall sein. Bitte versuchen Sie es später noch einmal.
                    </Alert>
              }

              {([PAGE_REGISTER, PAGE_FILLPROFILE].includes(loginPage)) &&
                <Panel className='text-left'>
                  <div className='form-horizontal'>

                    {loginPage == PAGE_REGISTER && cg("E-Mail", "login", "text", true, "Zur Anmeldung am Portal verwenden Sie zukünftig diese E-Mail Adresse")}
                    {cg("Vorname", "vorname", "text", true)}
                    {cg("Name", "name", "text", true)}
                    {loginPage == PAGE_REGISTER && <span>
                      {cg("Passwort", "password", "password", true, "Bitte geben Sie ein Passwort mit mindestens 8 Zeichen ein, darunter sowohl Buchstaben als auch Zahlen")}
                      {cg("Passwort Wiederholung", "password_repeat", "password", true, "Bitte geben Sie zur Sicherheit das eingegebene Passwort erneut ein")}
                    </span>
                    }
                    <Row className='required-container'>
                      <Col sm={5} />
                      <Col sm={6} className='required' style={{ paddingTop: "6px" }}>Pflichtfelder</Col>
                    </Row>
                  </div>
                </Panel>
              }

              {loginPage == PAGE_LOGIN &&
                <span>
                  <FormGroup className='form-group'>
                    <FormControl
                      name='login' autoFocus
                      placeholder='Matrikelnummer oder externe E-Mail-Adresse' value={this.state.login}
                      onChange={evt => this.setState({ login: evt.target.value })} />
                    <FormText>{loginPage == PAGE_LOGIN && [<p key={uuidv4()}>Als Hilfskraft melden Sie sich bitte mit Ihrem ZIM-Account an. <RegisterLink1 key={uuidv4()} onClick={() => this.setState({ loginPage: 1 })} /></p>,
                                                           <RegisterLink2 key={uuidv4()} onClick={() => this.setState({ loginPage: 1 })} />]
                    }
                    </FormText>
                    <div style={{ position: "relative" }}>
                      <FormControl
                        name='password'
                        type={showPassword ? "text" : "password"}
                        placeholder='Passwort'
                        value={this.state.password}
                        onChange={evt => this.setState({ password: evt.target.value })} />
                    </div>
                    <div style={{ textAlign: "right", marginTop: "5px" }}>
                      <a
                        href="#"
                        onClick={e => {
                          e.preventDefault();
                          this.togglePasswordVisibility();
                        }}
                        style={{ fontSize: "12px", textDecoration: "none" }}
                      >
                        {showPassword ? "Passwort verbergen" : "Passwort anzeigen"}
                      </a>
                    </div>
                  </FormGroup>

                </span>
              }

              {loginPage == PAGE_LOGIN && <span><button type='submit' className='btn btn-primary block full-width m-b'>Login</button>
                <br /><Link style={{ textDecoration: "none" }} onClick={() => this.setState({ loginPage: PAGE_PWD_RESET })}>Passwort vergessen?</Link></span>
              }
              {loginPage == PAGE_REGISTER && <span><button type='submit' className='btn btn-primary block full-width m-b'>Registrieren</button>
                <a onClick={() => this.setState({ loginPage: 0, errorMessage: null, errorFlashToggle: 0 })}>Weiter zur Anmeldeseite</a></span>}
              {loginPage == PAGE_FILLPROFILE && <button type='submit' className='btn btn-primary block full-width m-b'>Weiter zur Anwendung</button>}

              {loginPage == PAGE_PWD_RESET && (
                <Panel className='text-left'>
                  <div>
                    <p>Sollte es sich um einen ZIM-Account (endend in '@uni-wuppertal.de') handeln, können Sie das Passwort nur über die dort
                      verfügbare Funktion (<a target=' ' href='https://account.uni-wuppertal.de/pin_passwd.php?win_par=pass'>Link</a>) zurücksetzen.</p>

                    <p>Sollten Sie das Passwort für einen lokal registrierten Account vergessen haben, können Sie dieses zurücksetzen, wenn Sie dem Link in der E-Mail folgen,
                      die wir Ihnen auf die unten genannte Adresse senden.</p>
                    <br />
                    <FormGroup className='form-group'>
                      <FormControl
                        name='login' autoFocus
                        placeholder='E-Mail' value={this.state.login}
                        onChange={evt => this.setState({ login: evt.target.value })} />
                      <Button style={{ marginTop: "2px" }} variant='primary' onClick={this.process}> E-Mail versenden </Button>
                    </FormGroup>
                  </div></Panel>)
              }
              {loginPage == PAGE_PWD_RESET_INFO && (
                <Panel className='text-left'>
                  <div>
                    <p>Wir haben die E-Mail mit dem Link zum Zurücksetzen des Passworts an Sie versendet</p>
                    <p>Bitte sehen Sie in Ihrem Postfach nach und folgen Sie den Anweisungen in der E-Mail.</p>
                    <br />
                    <a onClick={() => this.setState({ loginPage: 0, errorMessage: null, errorFlashToggle: 0 })}>Zurück zur Anmeldeseite</a>
                  </div></Panel>)
              }


            </form>
          }
          {/* Spamschutz durch display:none */}
          <p className='m-t'> <small>Support: eportal<span style={{ display: "none" }}>buw</span>@uni-wuppertal.de<br />
            Informationen zum Datenschutz im Zusammenhang mit dem e-Portal erhalten Sie <Link to='/datenschutz'>hier</Link>.<br />
            ProUnix GmbH - e-Portal</small> {serverinfo && <span><br /><small>Rev. {serverinfo.revision}</small></span>}  </p>

        </div>
      </div>
      <DashboardFooter pinBottom />
    </span>;
  }

  process = e => {
    e.preventDefault();
    const { login, password, password_repeat, name, vorname, email, serverinfo } = this.state;

    this.setState({ errorMessage: null });

    switch (this.state.loginPage) {
      case PAGE_LOGIN:
        // Login
        setTimeout(() => {
          this.setState({ errorMessage: null, errorFlashToggle: 0 });
          this.props.login(login, password, serverinfo).then(result => {
            if (result.ec === "2") {
              this.setState(prevState => ({
                errorMessage: result.um || "Anmeldung fehlgeschlagen",
                errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
                wartungshinweisePopup: false,
              }));
            } else if (result.ec === "1") {
              this.setState(() => ({
                wartungshinweisePopup: true,
              }));
            } else if (result.needProfileData) {
              // Wenn Login nicht alle Daten geliefert hat, fehlende Werte eingeben lassen
              this.setState({ loginPage: PAGE_FILLPROFILE, continueLogin: result.onProfileOk, userData: result });
            }
            return null;
          }).catch(() => {
            this.setState(prevState => ({
              errorMessage: "Anmeldung fehlgeschlagen",
              errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
            }));
          });
        });

        return false;
      case PAGE_REGISTER:
        // Registrierung

        // Validierung

        if (!login || !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.exec(login)) {
          this.setState(prevState => ({
            errorMessage: "Bitte geben Sie Ihre E-Mail Adresse ein",
            errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
          }));
          return false;
        }

        if (login.toLowerCase().endsWith("@uni-wuppertal.de")) {
          this.setState(prevState => ({
            errorMessage: "Sie haben einen ZIM Account verwendet. Bitte melden Sie sich über die Anmeldeseite an.",
            errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
          }));
          return false;
        }


        if (!vorname) {
          this.setState(prevState => ({
            errorMessage: "Bitte geben Sie Ihren Vornamen ein",
            errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
          }));
          return false;
        }
        if (!name) {
          this.setState(prevState => ({
            errorMessage: "Bitte geben Sie Ihren Namen ein",
            errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
          }));
          return false;
        }
        if (_.isEmpty(password)) {
          this.setState(prevState => ({
            errorMessage: "Bitte geben Sie ein Passwort ein",
            errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
          }));
          return false;
        }
        if (_.isEmpty(password_repeat)) {
          this.setState(prevState => ({
            errorMessage: "Bitte wiederholen Sie die Passwort-Eingabe",
            errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
          }));
          return false;
        }

        if (password !== password_repeat) {
          this.setState(prevState => ({
            errorMessage: "Die Passwortwiederholung stimmt nicht mit der Eingabe überein",
            errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
          }));
          return false;
        }

        if (_.isEmpty(password_repeat)) {
          this.setState(prevState => ({
            errorMessage: "Bitte wiederholen Sie die Passwort-Eingabe",
            errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
          }));
          return false;
        }


        setTimeout(() => {
          this.setState({ errorMessage: null, errorFlashToggle: 0 });
          this.props.register(login, password, name, vorname, email).then(result => {
            if (!result && !result.ok) {
              this.setState(prevState => ({
                errorMessage: "Registrierung fehlgeschlagen",
                errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
              }));
            } else {
              if (result.ok == true) {
                // Infoseite zum Versenden des Links
                this.setState({ name: null, vorname: null, email: null });
                setTimeout(() => this.setState({ loginPage: PAGE_MAILSENT }));
              }
            }
          }).catch(err => {
            this.setState(prevState => ({
              errorMessage: err.message,
              errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
            }));
          });
        });
        return false;
      case PAGE_FILLPROFILE: {
        // Login fortsetzen nach Ausfüllen fehlender Profilinfo
        const u = this.state.userData;
        u.name = name;
        u.vorname = vorname;

        // Validierung:
        if (!vorname) {
          this.setState(prevState => ({
            errorMessage: "Bitte geben Sie Ihren Vornamen ein",
            errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
          }));
          return false;
        }
        if (!name) {
          this.setState(prevState => ({
            errorMessage: "Bitte geben Sie Ihren Namen ein",
            errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
          }));
          return false;
        }

        const update = async() => {
          await apifetch(`/api/shknutzer/nutzer`, {
            method: "PUT",
            body: JSON.stringify({ n_name: u.name, n_vorname: u.vorname }),
          });
        };
        this.state.continueLogin(this.state.userData); // vor dem update(), damit Token bekannt ist
        update();
        break;
      }
      case PAGE_PWD_RESET: {
        // Link für Passwortänderung zusenden
        const reset = async() => {
          try {
            await apifetch(`/api/shkauthentifizierung/vergessen`, {
              method: "POST",
              body: JSON.stringify({ login: login }),
            });
            this.setState({ loginPage: PAGE_PWD_RESET_INFO });
          } catch(err) {
            this.setState(prevState => ({
              errorMessage: err.response.um,
              errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
            }));
          }
        };
        reset();
      }
    }
  };
}
